import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import img2 from '../../../assets/images/home_page_4/product/02.png';
import img3 from '../../../assets/images/home_page_4/product/03.png';
import img12 from "../../../assets/images/home_page_4/product/12.png";
import img9 from "../../../assets/images/home_page_4/product/09.png";
import img13 from "../../../assets/images/home_page_4/product/13.png";
import img10 from "../../../assets/images/home_page_4/product/10.png";
import img14 from "../../../assets/images/home_page_4/product/14.png";
import img15 from "../../../assets/images/home_page_4/product/15.png";
import img16 from "../../../assets/images/home_page_4/product/16.png";

const settings = {
    slidesToShow: 1,
    dots: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
};

const products = [
    { id: 1, img: img12, title: "Sony A7 III Mirrorless Camera with 4K Video", price: "$159.77", rating: 3 },
    { id: 2, img: img9, title: "Sony A7 III Mirrorless Camera with 4K Video", price: "$159.77", rating: 3 },
    { id: 3, img: img13, title: "Sony A7 III Mirrorless Camera with 4K Video", price: "$159.77", rating: 3 },
    { id: 4, img: img10, title: "Sony A7 III Mirrorless Camera with 4K Video", price: "$159.77", rating: 3 },
    { id: 5, img: img14, title: "Sony A7 III Mirrorless Camera with 4K Video", price: "$159.77", rating: 3 },
    { id: 6, img: img15, title: "Sony A7 III Mirrorless Camera with 4K Video", price: "$159.77", rating: 3 },
];

const HomeProductTwo = () => {
    return (
        <div>
            <section id="home-product-two" className="home-product-two-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="row">
                                {products.map((product, index) => (
                                    <div className="col-lg-6 col-md-6" key={product.id}>
                                        <div className="home-product-one-sidebar-block">
                                            <div className="row">
                                                <div className="col-lg-4 col-5">
                                                    <div className="home-product-one-sidebar-img">
                                                        <Link to="/ShopDetails" title="">
                                                            <img src={product.img} className="img-fluid" alt="" />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-8 col-7">
                                                    <div className="home-product-one-sidebar-dtl home-product-dtls">
                                                        <ul>
                                                            {[...Array(5)].map((_, i) => (
                                                                <li className="icons" key={i}>
                                                                    <i className="flaticon-star"></i>
                                                                </li>
                                                            ))}
                                                            <li className="total-rating">({product.rating})</li>
                                                        </ul>
                                                        <div className="deals-product-dtls">
                                                            <h4 className="deals-product-heading">
                                                                <Link to="/ShopDetails" title="">{product.title}</Link>
                                                            </h4>
                                                            <div className="price">{product.price} <s>$</s><s>{product.price}</s></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="home-product-block">
                                <Slider className="slider home-product-one-autoplay" {...settings} dots='true'>
                                    <div className="home-product-one-img-dtl">
                                        <div className="home-product-img">
                                            <Link to="/ShopDetails" title="">
                                                <img src={img2} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div className="home-product-dtls text-center">
                                            <ul>
                                                {[...Array(5)].map((_, i) => (
                                                    <li className="icons" key={i}>
                                                        <i className="flaticon-star"></i>
                                                    </li>
                                                ))}
                                                <li className="total-rating">3 reviews</li>
                                            </ul>
                                            <h4 className="home-product-heading">
                                                <Link to="/ShopDetails" title="">HP Victus 16-e00244AX GTX 1650 Gaming Laptop 16.1” FHD 144Hz</Link>
                                            </h4>
                                            <div className="product-price-cart-block">
                                                <div className="home-product-price">
                                                    <span>$1,246.26</span>$1,000.00
                                                </div>
                                            </div>
                                            <div className="progress-block">
                                                <progress className="progress-bar" value="60" max="100"></progress>
                                                <div className="product-avail">the available products: <b>49</b></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="home-product-one-img-dtl">
                                        <div className="home-product-img">
                                            <Link to="/ShopDetails" title="">
                                                <img src={img3} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div className="home-product-dtls text-center">
                                            <ul>
                                                {[...Array(5)].map((_, i) => (
                                                    <li className="icons" key={i}>
                                                        <i className="flaticon-star"></i>
                                                    </li>
                                                ))}
                                                <li className="total-rating">3 reviews</li>
                                            </ul>
                                            <h4 className="home-product-heading">
                                                <Link to="/ShopDetails" title="">HP Victus 16-e00244AX GTX 1650 Gaming Laptop 16.1” FHD 144Hz</Link>
                                            </h4>
                                            <div className="product-price-cart-block">
                                                <div className="home-product-price">
                                                    <span>$1,246.26</span>$1,000.00
                                                </div>
                                            </div>
                                            <div className="progress-block">
                                                <progress className="progress-bar" value="60" max="100"></progress>
                                                <div className="product-avail">the available products: <b>49</b></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="home-product-one-img-dtl">
                                        <div className="home-product-img">
                                            <Link to="/ShopDetails" title="">
                                                <img src={img16} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div className="home-product-dtls text-center">
                                            <ul>
                                                {[...Array(5)].map((_, i) => (
                                                    <li className="icons" key={i}>
                                                        <i className="flaticon-star"></i>
                                                    </li>
                                                ))}
                                                <li className="total-rating">3 reviews</li>
                                            </ul>
                                            <h4 className="home-product-heading">
                                                <Link to="/ShopDetails" title="">HP Victus 16-e00244AX GTX 1650 Gaming Laptop 16.1” FHD 144Hz</Link>
                                            </h4>
                                            <div className="product-price-cart-block">
                                                <div className="home-product-price">
                                                    <span>$1,246.26</span>$1,000.00
                                                </div>
                                            </div>
                                            <div className="progress-block">
                                                <progress className="progress-bar" value="60" max="100"></progress>
                                                <div className="product-avail">the available products: <b>49</b></div>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomeProductTwo;